module.exports = __webpack_public_path__ + "img/beginners-series.7f04880.jpg";